<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="content" v-html="globalObj.auth_org.content">123</div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'globalObj'
    ]),
    components:{
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'授权机构', href:'/'},
            ],
            orgList:[],
            type:0,
        }
    },
    mounted(){
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}
.content{
    width: 1120px;
    margin: auto;
    box-sizing: border-box;
    padding: 30px;
    img{
        max-width: 100%;
    }
}
</style>
